define(['exports', 'lodash', 'react', 'prop-types', 'material-ui', 'react-onclickoutside'], function (exports, _lodash, _react, _propTypes, _materialUi, _reactOnclickoutside) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _lodash2 = _interopRequireDefault(_lodash);

	var _react2 = _interopRequireDefault(_react);

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var NavMenu = function (_React$Component) {
		_inherits(NavMenu, _React$Component);

		function NavMenu(props) {
			_classCallCheck(this, NavMenu);

			var _this = _possibleConstructorReturn(this, (NavMenu.__proto__ || Object.getPrototypeOf(NavMenu)).call(this, props));

			_this.state = { menuDisplayed: false };
			return _this;
		}

		_createClass(NavMenu, [{
			key: 'showNavMenu',
			value: function showNavMenu(show) {
				this.props.displayHandler(show);
				this.state.menuDisplayed = show;
			}
		}, {
			key: 'handleClickOutside',
			value: function handleClickOutside(evt) {
				this.showNavMenu(false);
			}
		}, {
			key: 'handleMenuClick',
			value: function handleMenuClick(evt) {
				if (!this.state.menuDisplayed) {
					this.showNavMenu(true);
				} else {
					this.showNavMenu(false);
				}
			}
		}, {
			key: 'handleSubmenuItemClick',
			value: function handleSubmenuItemClick(value, evt) {
				evt.stopPropagation();

				this.showNavMenu(false);

				var redirectLinks = this.props.redirectLinks;
				var redirectLink = redirectLinks[_lodash2.default.camelCase(value)];

				redirectLink();
			}
		}, {
			key: 'renderNavSubmenu',
			value: function renderNavSubmenu() {
				var _this2 = this;

				var submenu = this.props.submenu;


				return _lodash2.default.map(submenu, function (value, key) {
					return _react2.default.createElement(
						_materialUi.MenuItem,
						{ key: key, style: { color: '#757575', letterSpacing: '0.08rem', fontFamily: 'Poppins' }, onTouchTap: _this2.handleSubmenuItemClick.bind(_this2, value) },
						value
					);
				});
			}
		}, {
			key: 'renderNavMenu',
			value: function renderNavMenu() {
				var display = this.props.display;


				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						_materialUi.Paper,
						{ style: {
								'position': 'absolute',
								'top': '50px', right: '10px',
								'display': display ? 'block' : 'none',
								'text-align': 'left'
							} },
						_react2.default.createElement(
							_materialUi.Menu,
							{
								openDirection: 'top-left',
								autoWidth: false },
							this.renderNavSubmenu()
						)
					)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    navElement = _props.navElement,
				    menuTitle = _props.menuTitle;

				return _react2.default.createElement(
					'div',
					{ className: 'pt2',
						onTouchTap: this.handleMenuClick.bind(this) },
					_react2.default.createElement(
						'div',
						{ className: 'flex items-center' },
						_react2.default.createElement(
							'div',
							null,
							navElement
						),
						_react2.default.createElement(
							'div',
							{ className: 'menu-text pl1' },
							menuTitle && menuTitle
						)
					),
					this.renderNavMenu()
				);
			}
		}]);

		return NavMenu;
	}(_react2.default.Component);

	NavMenu.propTypes = {
		display: _propTypes2.default.bool.isRequired,
		displayHandler: _propTypes2.default.func.isRequired,
		redirectLinks: _propTypes2.default.object.isRequired,
		navElement: _propTypes2.default.element.isRequired,
		menuTitle: _propTypes2.default.string.isRequired,
		submenu: _propTypes2.default.object.isRequired
	};

	exports.default = (0, _reactOnclickoutside2.default)(NavMenu);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/NavMenu.js
// module id = 1171
// module chunks = 0